module.exports = __webpack_public_path__ + "static/media/VisaVerified.b43b93a2.svg";